import { Component, EventEmitter, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { USER_TYPES } from '../../constants';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-generic-toggle-switch',
    standalone: true,
    imports: [CommonModule],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: GenericToggleSwitchComponent,
        multi: true
    }],
    template: `
    <div class="toggle-container" (click)="toggle()">
        <div class="toggle-slider" [class.toggle-right]="activo()" [class.active]="activo()"></div>
        <div class="toggle-option" [class.active]="!activo()">
        </div>
        <div class="toggle-option" [class.active]="activo()">
        </div>
    </div>
  `,
    styles: [`
    .toggle-container {
        position: relative;
        display: flex;
        justify-content: space-between;
        width: 60px;
        border: 1px solid #00000080;
        border-radius: 50px;
        padding: 2px;
        background-color: transparent;
        cursor: pointer;
        font-family: Arial, sans-serif;
        user-select: none;
        overflow: hidden;
        }

        .toggle-slider {
        position: absolute;
        top: 2px;
        bottom: 2px;
        left: 2px;
        width: calc(50% - 2px);
        background-color: #999;
        border-radius: 50px;
        transition: transform 0.3s ease;
        z-index: 0;
        }

        .toggle-slider.active {
        background-color: red;
        }

        .toggle-slider.toggle-right {
        transform: translateX(100%);
        }

        .toggle-option {
        flex: 1;
        text-align: center;
        line-height: 24px;
        height: 24px;
        z-index: 1;
        color: #999;
        font-size: 14px;
        position: relative;
        }

        .toggle-option.active {
        // color: #F5F5F5;
        font-weight: 600;
        }
  `]
})
export class GenericToggleSwitchComponent implements ControlValueAccessor {
    isDisabled = false;
    private onChange = (_: any) => { };
    private onTouched = () => { };
    activo = signal(false);

    writeValue(value: any): void {
        this.activo.set(value ?? false);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    @Output() changeEvent = new EventEmitter<boolean>();

    toggle() {
        if (this.isDisabled) return;
        this.activo.update(v => !v);
        this.onChange(this.activo());
        this.onTouched();
        this.changeEvent.emit(this.activo());
    }

}
